<template>
  <tr class="signal-snippet" :class="{ loading: loading }">

    <td>
      <a @click.prevent="openShowSignalModal">
        <span v-html="sanitizeDescription(signal.description)"></span>
      </a>
    </td>
    <td>
      {{ signal.comment }}
    </td>

    <td>
      {{ dateFormatter(signal.created_at) }}
    </td>

    <td v-if="showCustomer">
      <CustomerBadgeComponent :customer="signal.customer.data" />
<!--            v-if="hasCustomer"-->
    </td>

    <td class="text-center">
      <a-tooltip placement="top">
        <template slot="title">
          <span>Zichtbaar voor de klant</span>
        </template>
          <eye-icon v-if="isVisibleForCustomer" class="icon-medium icon-green"></eye-icon>
      </a-tooltip>

      <a-tooltip placement="top">
        <template slot="title">
          <span>Niet zichtbaar voor de klant</span>
        </template>
        <eye-off-icon v-if="!isVisibleForCustomer" class="icon-medium"></eye-off-icon>
      </a-tooltip>
    </td>

    <td class="text-right">
      <!-- TODO: refactor action buttons into component (?) -->
      <div v-if="signalIsActive">

        <div v-if="$mq !== 'mobile' && $mq !== 'tablet'">
          <a-popover title="Verbergen tot" trigger="click hover" placement="leftTop">
            <template slot="content">
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'days')">
                  <bell-sleep-icon></bell-sleep-icon> Morgen
                </a>
              </p>
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'weeks')">
                  <bell-sleep-icon></bell-sleep-icon> Volgende week
                </a>
              </p>
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'months')">
                  <bell-sleep-icon></bell-sleep-icon> Volgende maand
                </a>
              </p>
            </template>
            <a-button>
              <dots-vertical-icon></dots-vertical-icon>
            </a-button>
          </a-popover>

          <a-tooltip placement="top">
            <template slot="title">
              <span>Signaal bekijken</span>
            </template>
            <a-button @click="openShowSignalModal">
              <eye-icon></eye-icon>
            </a-button>
          </a-tooltip>

          <a-tooltip placement="top">
            <template slot="title">
              <span>Signaal verwijderen</span>
            </template>
            <a-popconfirm
                title="Wilt u het signaal verwijderen?"
                placement="leftTop"
                ok-text="Ja"
                cancel-text="Annuleer"
                @confirm="confirmDelete(signal.id)"
            >
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a-button type="danger" ghost>
                <delete-icon></delete-icon>
              </a-button>
            </a-popconfirm>
          </a-tooltip>

          <a-tooltip placement="top">
            <template slot="title">
              <span>Signaal afronden</span>
            </template>
            <a-button @click="openFinishModal(signal.id)" type="primary">
              <check-icon></check-icon>
            </a-button>
          </a-tooltip>
        </div>

        <div v-else>
          <a-popover title="Verbergen tot" trigger="click hover" placement="leftTop">
            <template slot="content">
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'days')">
                  <bell-sleep-icon></bell-sleep-icon> Morgen
                </a>
              </p>
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'weeks')">
                  <bell-sleep-icon></bell-sleep-icon> Volgende week
                </a>
              </p>
              <p>
                <a @click.prevent="snoozeSignal(signal.id, 'months')">
                  <bell-sleep-icon></bell-sleep-icon> Volgende maand
                </a>
              </p>
              <hr/>
              <p>
                <a @click.prevent="openShowSignalModal">
                  <eye-icon></eye-icon> Signaal bekijken
                </a>
              </p>
              <p>
                <a @click.prevent="openFinishModal(signal.id)">
                  <check-icon></check-icon> Afronden
                </a>
              </p>
              <p>
                <a-popconfirm
                    title="Wilt u het signaal verwijderen?"
                    placement="leftTop"
                    ok-text="Ja"
                    cancel-text="Annuleer"
                    @confirm="confirmDelete(signal.id)"
                >
                  <a-icon slot="icon" type="question-circle-o" style="color: red" />
                  <a>
                    <delete-icon></delete-icon> Verwijderen
                  </a>
                </a-popconfirm>
              </p>
            </template>
            <a-button size="small">
              <dots-vertical-icon></dots-vertical-icon>
            </a-button>
          </a-popover>
        </div>

      </div>

      <div v-else>
        <a-tooltip placement="top">
          <template slot="title">
            <span>Signaal verwijderen</span>
          </template>
          <a-popconfirm
              title="Wilt u het signaal verwijderen?"
              placement="leftTop"
              ok-text="Ja"
              cancel-text="Annuleer"
              @confirm="confirmDelete(signal.id)"
          >
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a-button type="danger" ghost :size="($mq !== 'mobile' && $mq !== 'tablet') ? 'default' : 'small'">
              <delete-icon></delete-icon>
            </a-button>
          </a-popconfirm>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <span>Signaal is afgerond</span>
          </template>
          <a-button class="btn-success" :size="($mq !== 'mobile' && $mq !== 'tablet') ? 'default' : 'small'">
            <check-icon></check-icon>
          </a-button>
        </a-tooltip>
      </div>

    </td>

    <a-modal
      title="Signaal afronden"
      :visible="showFinishModal"
      ok-text="Afronden"
      cancel-text="Annuleren"
      @ok="finishSignal()"
      @cancel="closeFinishModal"
      :closable="false"
      :maskClosable="false"
    >
      <a-form-model :model="form">
        <a-form-model-item label="Notitie (optioneel)">
          <a-input v-model="form.comment" type="textarea" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <show-signal-modal-component
        :signal="signal"
        :visible="showSignalModal"
        @close="closeShowSignalModal"
    />

  </tr>
</template>

<script>
import signalApi from '~/api/signal';
import {DateFormatEnum, SignalStatusEnum} from "~/enums";
import CustomerBadgeComponent from '~/modules/customer/components/BadgeComponent';
import ShowSignalModalComponent from '~/modules/signals/components/ShowSignalModalComponent';
import DOMPurify from "dompurify";

const moment = require('moment');

export default {
  name: 'SignalRowComponent',
  props: {
    signal: {
      type: Object,
      required: true,
    },
    showCustomer: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    CustomerBadgeComponent,
    ShowSignalModalComponent
  },
  data() {
    return {
      loading: false,
      SignalStatusEnum: SignalStatusEnum,
      DateFormatEnum: DateFormatEnum,
      showFinishModal: false,
      form: {
        comment: null,
      },
      size: 'default',
      showSignalModal: false,
    };
  },
  computed: {
    userId() {
      return window.state.user.id;
    },
    hasSignalQueryData() {
      return 'signal_query' in this.signal
          && 'data' in this.signal.signal_query
          && typeof this.signal.signal_query.data !== undefined;
    },
    isVisibleForCustomer() {
      return this.hasSignalQueryData
          && 'visible_for_customer' in this.signal.signal_query.data
          && this.signal.signal_query.data.visible_for_customer !== null
          ? this.signal.signal_query.data.visible_for_customer
          : false;
    },
    signalIsActive() {
      return this.signal.status === SignalStatusEnum.ACTIVE && (this.signal.ignore_from === null || moment(this.signal.ignore_from).isSameOrAfter(moment()))
    }
  },
  methods: {
    dateFormatter(date) {
      return moment(date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    },
    snoozeSignal(signalId, period = 'days') {
      this.loading = true;
      let dateMutation = moment({hour:0, minute:0}).add(1, period);
      let snoozedUntil = moment(dateMutation, moment.ISO_8601).format();

      signalApi.snooze(signalId, snoozedUntil)
        .then((response) => {
          this.$emit('reload-signals');
          this.$notification['success']({
            message: 'success',
            description: 'Het signaal is succesvol gesnoozed',
          });
        })
        .catch(() => {
          this.$notification['error']({
            message: 'Er ging iets mis',
            description: 'Het is niet gelukt om het signaal te snoozen',
          });
        })
        .finally(() => {
          this.loading = false;
      });
    },
    openFinishModal(signalId) {
      this.showFinishModal = true;
      this.form.id = signalId;
      this.form.status = 1;
      this.form.finishedBy = this.userId;
    },
    finishSignal() {
      signalApi.finish(this.form)
        .then((response) => {
          this.$emit('reload-signals');
          this.makeTaskConfirm(this.form.id);
        })
        .catch(() => {
          this.$notification['error']({
            message: 'Error',
            description: 'Het is niet gelukt het signaal af te ronden',
          });
        })
        .finally(() => {
          this.closeFinishModal();
        });
    },
    closeFinishModal() {
      this.form = { comment: null };
      this.showFinishModal = false;
    },
    makeTaskConfirm(signalId) {
      this.$confirm({
        title: 'Taak aanmaken',
        content: 'Wilt u een taak aanmaken voor dit afgeronde signaal?',
        okText: 'Ja',
        cancelText: 'Nee',
        onOk: () => {
          signalApi.createTaskUrl(signalId)
              .then((response) => { window.location = response });
        },
        onCancel: () => {},
        class: 'test',
      });
    },
    confirmDelete(signalId) {
      this.loading = true;
      signalApi.deleteSignal(signalId)
          .then((response) => {
            this.$emit('reload-signals');
          })
          .catch((error) => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om het signaal te verwijderen',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    openShowSignalModal() {
      this.showSignalModal = true;
    },
    closeShowSignalModal() {
      this.showSignalModal = false;
    },
    sanitizeDescription(description) {
      return DOMPurify.sanitize(description);
    },
  },
};
</script>

<style scoped>
.loading {
  opacity: .5;
}
.btn-success {
  color: rgb(255, 255, 255);
  background-color: rgb(109, 194, 135);
  border-color: rgba(109, 194, 135, 0.5);
}
.icon-medium {
  font-size: 1.5em;
}
.icon-green {
  color: rgb(109, 194, 135);
}
</style>
